"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserTable = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ProgressiveList = _interopRequireDefault(require("../ProgressiveList"));

const Container = _styledComponents.default.div`
  width: 100%;
`;
const CellContent = (0, _styledComponents.default)(_blocks.Main)`
  line-height: 1.4;
`;

class UserTable extends React.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "ref", void 0);
    (0, _defineProperty2.default)(this, "getInitialRenderCount", userCount => {
      // Determine if the group length is small enough to render all at once
      // If less than 6 groups, render all of em, otherwise limit to 6 initially
      const DEFAULT_RENDER_LIMIT = 30;
      return userCount > DEFAULT_RENDER_LIMIT ? DEFAULT_RENDER_LIMIT : userCount;
    });
    (0, _defineProperty2.default)(this, "renderGroup", index => {
      const {
        users,
        onRowSelect
      } = this.props;
      const user = users[index];
      if (!user) return null;
      return /*#__PURE__*/React.createElement(_blocks.DataGridRow, {
        "data-cy": "user-row",
        onClick: () => onRowSelect(user),
        key: user.id,
        cursor: "pointer"
      }, /*#__PURE__*/React.createElement(_blocks.DataGridCell, {
        "data-cy": "user-fullName"
      }, /*#__PURE__*/React.createElement(CellContent, null, user.fullName)), /*#__PURE__*/React.createElement(_blocks.DataGridCell, {
        "data-cy": "user-email"
      }, /*#__PURE__*/React.createElement(CellContent, null, user.email)), /*#__PURE__*/React.createElement(_blocks.DataGridCell, {
        "data-cy": "user-role"
      }, /*#__PURE__*/React.createElement(CellContent, null, user.role)), /*#__PURE__*/React.createElement(_blocks.DataGridCell, {
        "data-cy": "user-group"
      }, /*#__PURE__*/React.createElement(CellContent, null, user.groups.join(', '))), /*#__PURE__*/React.createElement(_blocks.DataGridCell, {
        "data-cy": "user-status"
      }, /*#__PURE__*/React.createElement(CellContent, null, user.status)));
    });
    this.ref = /*#__PURE__*/React.createRef();
  }

  render() {
    const {
      users
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, {
      ref: this.ref
    }, /*#__PURE__*/React.createElement(_blocks.DataGrid, {
      grow: [3, 5, 6],
      cellProps: {
        type: 'dense',
        density: 'default'
      }
    }, /*#__PURE__*/React.createElement(_blocks.DataGridHeader, null, /*#__PURE__*/React.createElement(_blocks.DataGridHeading, null, /*#__PURE__*/React.createElement(_blocks.Main, null, "Full Name")), /*#__PURE__*/React.createElement(_blocks.DataGridHeading, null, /*#__PURE__*/React.createElement(_blocks.Main, null, "Email")), /*#__PURE__*/React.createElement(_blocks.DataGridHeading, null, /*#__PURE__*/React.createElement(_blocks.Main, null, "Role")), /*#__PURE__*/React.createElement(_blocks.DataGridHeading, null, /*#__PURE__*/React.createElement(_blocks.Main, null, "Group")), /*#__PURE__*/React.createElement(_blocks.DataGridHeading, null, /*#__PURE__*/React.createElement(_blocks.Main, null, "Status"))), /*#__PURE__*/React.createElement(_ProgressiveList.default, {
      initialAmount: this.getInitialRenderCount(users.length),
      useWindowScroll: true,
      progressiveAmount: 30,
      renderItem: this.renderGroup,
      rowCount: users.length,
      scrollParent: this.ref
    })));
  }

}

exports.UserTable = UserTable;